import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import * as sections from "../components/sections"
import Fallback from "../components/fallback"
import SEOHead from "../components/head"
import {
  Box,
  ButtonList,
  Container,
  Flex,
  Heading,
  Kicker,
  Section,
  Subhead,
  Text,
} from "../components/ui"
import Trending from "../components/trending-caraousel"
import TwoColumnHighlight from "../components/TwoColumnHighlight"
import  ApiDemoComponent from "../components/api-demo-component";

export default function Homepage(props) {
  const { homepage } = props.data
  
  // console.log("HomePage Blocks: ",homepage.blocks);
  
  const heroBlock = homepage.blocks.shift();
  let Component = sections[heroBlock.blocktype] || Fallback

  const ctaBlock = homepage.blocks.shift();
  let ComponentCTA = sections[ctaBlock.blocktype] || Fallback

  return (
    <Section>
    <Layout>
      
      {        
        <Component key={heroBlock.id} {...heroBlock} />
      } 
      { 
        <ComponentCTA key={ctaBlock.id} {...ctaBlock} />
      }
      {/* {
        <Subhead as="h2" center={true}>Search Farcaster Using AI</Subhead>
      } */}
      {/* {
        <Trending/>
      } */}

      {homepage.blocks.map((block) => {
        // console.log(block)
        const { id, blocktype, ...componentProps } = block
        Component = sections[blocktype] || Fallback
        return <Component key={id} {...componentProps} />
      })}
       {/* {
        <div>
        <main>
          <ApiDemoComponent />
        </main>
      </div> */}
      
    </Layout>
    </Section>
  )
}

export const Head = (props) => {
  const { homepage } = props.data
  return <SEOHead {...homepage} />
}


export const query = graphql`
  {
    homepage {
      id
      title
      description
      image {
        id
        url
      }
      blocks: content {
        id
        blocktype
        ...HomepageHeroContent
        ...PricingTableContent
        ...HomepageFeatureListContent
        ...HomepageTestimonialListContent
        ...HomepageBenefitListContent
        ...HomepageStatListContent
        ...HomepageLogoListContent
        ...HomepageCtaContent
        ...HomepageProductListContent
        ...TwoColumnFeatureContent
      }
    }
  }
`
